import { jsx as _jsx } from "react/jsx-runtime";
import ListWrap from "./ListWrap";
const ListWrapPreview = () => {
    return (_jsx(ListWrap, { dynamicList: [
            { label: "TPE" },
            { label: "Petites PME" },
            { label: "Petites collectivites" },
            { label: "Associations" },
            { label: "Structures publiques" },
        ] }));
};
export default ListWrapPreview;
